module.exports = __webpack_public_path__ + "static/13-vampire-ab57d45ed2a5ecf3ad5f50814c28589b.jpg";